import { Component } from '@angular/core';

@Component({
  selector: 'pui-form-body',
  templateUrl: 'form-body.component.html'
})
export class PuiFormBodyComponent {
}
